import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ExpenseIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 22 22" sx={{ height: '22px', width: '22px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M11 18.3332V3.6665M11 3.6665L5.5 9.1665M11 3.6665L16.5 9.1665"
        stroke="#FF5F57"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default ExpenseIcon;
